export default __webpack_public_path__ + "static/media/Background_00166.d557503a.png";